/*
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Korištenje ili javno objavljivanje ovog programskog koda ili bilo kojeg
 * njegovog dijela, nije dozvoljeno bez prethodnog pismenog odobrenja tvrtke Mali mol d.o.o.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 * <URL:http://www.malimol.hr>, <mailto:info@malimol.hr>
 */

/* eslint-disable no-console */
/* eslint-disable no-alert */

import './bootstrap';
import { createApp, h } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { useAppStore } from './stores/app';
import { VueCookieNext } from 'vue-cookie-next';
import { setupI18n, loadLocaleMessages } from './i18n-setup';
import { setAppRefs } from './modules/api';

import VueResizeObserver from 'vue-resize-observer';

import { PrimeVuePlugin } from "./plugins/PrimeVue";
import { FontAwesomePlugin } from "./plugins/FontAwesome";

import App from './components/App.vue'
import CalculationTable from "@/components/CalculationTable.vue";

import type { I18n } from 'vue-i18n';

export let i18n: I18n;

// Router and app will be set after async initialization
export let router: any;
export let app: any;

// Async initialization to break circular dependency
(async () => {
  // Guard against HMR double-mounting - use window to persist across module reloads
  if ((window as any).__VUE_APP_MOUNTED__) return;
  (window as any).__VUE_APP_MOUNTED__ = true;

  // Create Pinia and install on app FIRST (persistence plugin needs app context)
  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);
  app = createApp({render: ()=>h(App)});
  app.use(pinia);

  // Now stores can be used with full plugin support (persistence works)
  const appStore = useAppStore();

  i18n = setupI18n({
    globalInjection: true,
    legacy: false,
    locale: appStore.language,
    fallbackLocale: 'en'
  });

  // Load locale messages BEFORE mounting to avoid "key not found" warnings
  await loadLocaleMessages(i18n, appStore.language);

  // Dynamic import breaks the sync import cycle
  const { setupRouter } = await import('./router');
  router = setupRouter(i18n);

  // Set refs for api.ts to use (avoids circular dependency)
  setAppRefs(i18n, router);

  // One-time cleanup of old Vuex persisted state
  sessionStorage.removeItem('vuex');

  app.component('App', App);
  app.component("CalculationTable", CalculationTable);

  app
    .use(router)
    .use(i18n)
    .use(FontAwesomePlugin)
    .use(VueCookieNext)
    .use(PrimeVuePlugin)
    .use(VueResizeObserver)
    .mount("#app");
})();
